import { createFileRoute, Outlet } from '@tanstack/react-router'

/** Visits sit under the jobs in the trail: Service › Service jobs › SJ-00012 · 2. */
export const Route = createFileRoute('/_app/service/visits')({
  staticData: { crumb: 'serviceJobs' },
  component: Outlet,
})
